import { IVector3 } from '@seddi/math-v2';
import { stringifyColor } from '../resources/fabric';

interface FabricHolder {
  fabric: string;
  fabricColor?: IVector3;
}

/**
 * Returns true if the fabric/color combination matches.
 * @param holder Fabric holder object.
 * @param fabric Query fabric ID.
 * @param fabricColor Query fabric color stringified.
 */
export const isSameFabric = (
  holder: FabricHolder,
  fabric: string,
  fabricColor: string | undefined,
): boolean => {
  if (holder.fabric !== fabric) {
    return false;
  }
  if (!holder.fabricColor && fabricColor) {
    return false;
  }
  if (holder.fabricColor && !fabricColor) {
    return false;
  }
  if (holder.fabricColor && stringifyColor(holder.fabricColor) !== fabricColor) {
    return false;
  }
  return true;
};
